import { Typography } from 'src/app/components/Elements/Typography';
import { hipaa, privacy, termsAndConditions } from 'src/app/router/paths';
import type { ThemeColorType, ThemeSpaceType } from 'src/styles/theme';

import { Container, StyledLink } from './styles';

type TermsAndConditionsProps = {
  textColor: ThemeColorType;
  marginTop?: ThemeSpaceType;
  marginBottom?: ThemeSpaceType;
  disclaimerText?: string;
};
export const TermsAndConditions = ({
  disclaimerText,
  marginTop,
  marginBottom,
  textColor = 'white',
}: TermsAndConditionsProps) => {
  return (
    <Container marginTop={marginTop} marginBottom={marginBottom}>
      <Typography variant="small" color={textColor} marginBottom={'s2'}>
        I accept the Capsule <StyledLink to={termsAndConditions.toPath()}>Terms of Service</StyledLink>
        {', '}
        <StyledLink to={hipaa.toPath()}>HIPAA Policy</StyledLink>
        {', and '}
        <StyledLink to={privacy.toPath()}>Privacy Policy</StyledLink>.
      </Typography>

      {disclaimerText && (
        <Typography variant="small" color="white">
          {disclaimerText}
        </Typography>
      )}
    </Container>
  );
};
